import { render, staticRenderFns } from "./DutiesTaxesSidePanel.vue?vue&type=template&id=dbc0e54a&scoped=true"
import script from "./DutiesTaxesSidePanel.vue?vue&type=script&lang=ts"
export * from "./DutiesTaxesSidePanel.vue?vue&type=script&lang=ts"
import style0 from "./DutiesTaxesSidePanel.vue?vue&type=style&index=0&id=dbc0e54a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc0e54a",
  null
  
)

export default component.exports